/* ====================== PRODUCT CARD JS - JFASHION1 v3.3 (FIXED) ====================== */

(function() {
  'use strict';

  if (window.__jfashionProductCardsReady) return;
  window.__jfashionProductCardsReady = true;

  // ===== Quick View =====
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn) return;

    e.preventDefault();
    const handle = btn.dataset.productHandle;
    if (!handle) return;

    document.dispatchEvent(new CustomEvent('quick-view:open', {
      detail: { handle: handle }
    }));
  });

  // ===== Add to Cart =====
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    e.preventDefault();
    if (btn.disabled) return;

    const form = btn.closest('form');
    if (!form) return;

    const variantInput = form.querySelector('.product-card__variant-input');
    const variantId = variantInput?.value || btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.querySelector('.btn-text')?.textContent || btn.textContent;
    const loader = btn.querySelector('.btn-loader');
    const textSpan = btn.querySelector('.btn-text');

    btn.disabled = true;
    if (textSpan) textSpan.hidden = true;
    if (loader) loader.hidden = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add');
      return response.json();
    })
    .then(() => {
      if (textSpan) {
        textSpan.hidden = false;
        textSpan.textContent = window.jfashionStrings?.added || '✓ Added!';
      }
      btn.classList.add('is-success');

      document.dispatchEvent(new CustomEvent('cart:updated'));

      setTimeout(() => {
        btn.classList.remove('is-success');
        if (textSpan) textSpan.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    })
    .catch(() => {
      if (textSpan) {
        textSpan.hidden = false;
        textSpan.textContent = window.jfashionStrings?.error || 'Error!';
      }
      btn.classList.add('is-error');
      btn.disabled = false;

      setTimeout(() => {
        btn.classList.remove('is-error');
        if (textSpan) textSpan.textContent = originalText;
      }, 2000);
    })
    .finally(() => {
      if (loader) loader.hidden = true;
    });
  });

  // ===== Swatches Logic - FIXED =====
  function initSwatches(card) {
    if (card.dataset.swatchesReady) return;
    card.dataset.swatchesReady = 'true';

    const variantsDataEl = card.querySelector('.product-card__variants-data');
    if (!variantsDataEl) return;

    let variantsData;
    try {
      variantsData = JSON.parse(variantsDataEl.textContent || '[]');
    } catch(e) {
      console.warn('Product card: Invalid variants data', e);
      return;
    }

    const mainInput = card.querySelector('.product-card__variant-input');
    const mainImage = card.querySelector('img[id^="ProductCardImage"]');
    const cartBtn = card.querySelector('[data-add-to-cart]');
    const colorSwatches = card.querySelectorAll('.swatch--color');
    const sizeSwatches = card.querySelectorAll('.swatch--size');

    function updateVariant() {
      const activeColor = card.querySelector('.swatch--color.is-active')?.dataset.value;
      const activeSize = card.querySelector('.swatch--size.is-active')?.dataset.value;

      const foundVariant = variantsData.find(function(variant) {
        let match = true;
        if (activeColor && !variant.options.includes(activeColor)) match = false;
        if (activeSize && !variant.options.includes(activeSize)) match = false;
        return match;
      });

      if (foundVariant && mainInput) {
        mainInput.value = foundVariant.id;
      }

      if (foundVariant && cartBtn) {
        const textSpan = cartBtn.querySelector('.btn-text');
        if (foundVariant.available) {
          cartBtn.disabled = false;
          if (textSpan) textSpan.textContent = window.jfashionStrings?.addCart || 'Add to Cart';
          cartBtn.style.background = '';
          cartBtn.style.cursor = '';
        } else {
          cartBtn.disabled = true;
          if (textSpan) textSpan.textContent = window.jfashionStrings?.outStock || 'Out of Stock';
          cartBtn.style.background = '#ccc';
          cartBtn.style.cursor = 'not-allowed';
        }
      }
    }

    // Color swatches - FIXED IMAGE SWAP
    colorSwatches.forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Remove active from all color swatches
        colorSwatches.forEach(function(d) {
          d.classList.remove('is-active');
          d.setAttribute('aria-pressed', 'false');
        });

        // Add active to clicked
        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');

        // ===== IMAGE SWAP - FIXED =====
        if (mainImage) {
          const newSrc = this.dataset.variantImage;
          if (newSrc && newSrc !== mainImage.src) {
            // Smooth transition
            mainImage.style.opacity = '0.7';

            // Preload image
            const img = new Image();
            img.onload = function() {
              mainImage.src = newSrc;
              mainImage.style.opacity = '1';
            };
            img.onerror = function() {
              // If image fails, keep original
              mainImage.style.opacity = '1';
              console.warn('Failed to load variant image:', newSrc);
            };
            img.src = newSrc;
          }
        }

        updateVariant();
      });
    });

    // Size swatches
    sizeSwatches.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        sizeSwatches.forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });

        this.classList.add('is-active');
        this.setAttribute('aria-pressed', 'true');

        updateVariant();
      });
    });
  }

  // ===== Init cards =====
  function initCards() {
    document.querySelectorAll('.product-card:not([data-swatches-ready])').forEach(initSwatches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }

  // Re-init on dynamic content
  new MutationObserver(function(mutations) {
    let shouldInit = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (
          node.classList?.contains('product-card') ||
          node.querySelector?.('.product-card')
        )) {
          shouldInit = true;
        }
      });
    });
    if (shouldInit) initCards();
  }).observe(document.body, { childList: true, subtree: true });
})();